pagePrivate = true;
var pets = [];
var pOrder = [];

jQuery(function($){

	$.when( loginCheck ).then(function() {
		if (userLoggedIn) {

			$.when(petTypesGet(), petStatusesGet(), petsGet(), delReasonsGet()).then(function() {

				$('#pet_list').empty();
				let petCount = 0;
				$.each(pOrder, function(i,po) {
					let p = pets[po];
					if (p.created_by == userData.user) {
						petCount = petCount + 1;
						var pet = $('#pet_listing_prototype').clone().removeAttr('id').hide();
						pet.find('.pet_status').text((p.approved) ? 'Approved' : 'Pending Approval');

						pet.attr('id', 'pet_' + p.pet_id);
						pet.data('pet_id', p.pet_id);
						pet.find('.view_pet').data('pet_id', p.pet_id).attr('href', '/pet/' + p.pet_id);
						pet.find('.pet_type').text(pet_types[p.pet_type].name);
						pet.find('.pet_name').text(p.name);
						pet.find('.pet_color').html(p.color);
						pet.find('.pet_description').html(p.description);
						pet.find('.pet_collar').text(p.collar == 1 ? 'YES' : 'NO');
						pet.find('.del_pet').data('id', p.pet_id);
						//pet.find('.pet_status').text(pet_statuses[p.status].name);
						pet.find('.lost_date').text(moment(p.created).format("MMM Do YYYY"));
						pet.find('.pet_exp_date').text(moment(p.last_mod).add(2, 'w').format("MMM Do YYYY"));

						let dLeft = moment(p.last_mod).diff(moment(), 'days');
						//console.log(p.last_mod);
						//console.log(dLeft);
						if(dLeft > -12) {
							pet.find('.extend_pet').remove();
						} else {
							pet.find('.extend_pet').data('pet_id', p.pet_id);
						}

						if (p.photos.length) {
							let aif = '';
							let aifw = '';

							$.each(p.photos, function(i,pho) {
								if (pho.pp_id == p.highlight_photo) {
									aif = pho.filename;
								}
							})
							if (aif) {
								aifw = aif.replace(/\.[^/.]+$/, '.webp');
								pet.find('picture.highlight_photo > img').attr('src','/art/pet_photos/130sq/' + aif).attr('srcset', '/art/pet_photos/172sq/' + aif + ' 172w, /art/pet_photos/125sq/' + aif + ' 125w, /art/pet_photos/130sq/' + aif + ' 130w, /art/pet_photos/130sq/' + aif);
								pet.find('picture.highlight_photo > source').attr('srcset', '/art/pet_photos/172sq/' + aifw + ' 172w, /art/pet_photos/125sq/' + aifw + ' 125w, /art/pet_photos/130sq/' + aifw + ' 130w,/art/pet_photos/130sq/' + aifw);
							}
						} else {
							pet.find('picture.highlight_photo > img').hide();
						}
						pet.find('.view_pet').data('pet_id', p.pet_id);

						let linkType = (p.status==6) ? 'lost' : 'found'
						pet.find('.edit_pet').data('id', p.pet_id).attr('href', '/report-' + linkType + '-pet.html?pet[is_edit]=1&pet[pet_id]=' + p.pet_id);

						if (p.approved == 0) {
							pet.find('.edit_pet').removeClass('conf_link');
						}

						$('#pet_list').append(pet);
						pet.fadeIn();
					}
				});
				if (petCount == 0) {
					$('#pet_list').html('No Current Pet Listings');
				}


			});

			// Load their pets

		} else {
			window.location.replace('/login.html?return_url=' + window.location.pathname);
		}
	});



	$("#acct_phone").mask("(999) 999-9999");

	$(".clickme").click(function () {
		$(".content").slideToggle("slow");
	});

	function scrollToAnchor(aid){
		var aTag = $("a[name='"+ aid +"']");
		$('html,body').animate({scrollTop: aTag.offset().top},'fast');
	}

	if ($('#scrollTo').val()) {
		scrollToAnchor($('#scrollTo').val());
	}


	// Click hanlders for left menu

	$("#myaccount-container-left").on('click', '.list-group-item', function(e) {
		e.preventDefault();
		$("#myaccount-container-left .list-group-item").removeClass('active');
		$(this).addClass('active');

		if ($(this).hasClass('logout')) {
		} else {
			$("#myaccount-container-right .alert").hide();
			$("#" + $(this).data('divid')).show();
		    $('html, body').animate({scrollTop: 0}, 500);
		}
	});



	// change handlers for pop-up form fields to remove missing-data class once data has been entered
	$("#dialog-edit-password").on("change", ".required", function(){
		if ($(this).val()) {$(this).removeClass('missing-data');}
	});

	$("#dialog-edit-account").on("change", ".required", function(){
		if ($(this).val()) {$(this).removeClass('missing-data');}
	});

	$("#dialog-edit-addresses").on("change", ".required", function(){
		if ($(this).val()) {$(this).removeClass('missing-data');}
	});


	// Del link handler
	$(document).on('click', '.del_pet', function(e) {
		e.preventDefault();

		let lof;

		if (pets[$(this).data('id')].status == 6) {
			lof = 1;
		} else {
			lof = 2;
		}


		$('#del_reason_input').empty().change();
		$('#del_descr').val('');
		$('#del_reason_input').append('<option value="">Please Select</option>');
		$.each(del_statuses, function(i,d) {
			if (d.lorf == lof) {
				$('#del_reason_input').append('<option value="' + d.del_id + '">' + d.name + '</option>');
			}
		})

		$('#delModal').modal('show');
		$('.confirm_del').data('pet_id', $(this).data('id'));
	})


	$(document).on('change', '#del_reason_input', function() {
		if ($(this).val()) {
			$('.confirm_del').removeAttr('disabled');
		} else {
			$('.confirm_del').attr('disabled', 'disabled');
		}
	})


	$(document).on('click', '.confirm_del', function(e) {
		e.preventDefault();
		delPet($(this).data('pet_id'));
		$('#delModal').modal('hide');
	})

	// Submission handler for edit account request
	$(document).on("click", "#edit_acct_sub", function(e) {
		e.preventDefault();
		$("#pets-err").hide();
		$('#pets-wait-msg').html('<strong>Please Wait - saving changes</string> <i class="fa fa-spinner fa-pulse"></i>');
		$("#pets-wait").show();
		var formData = $('#account_form').serialize();
		// process the form
		$.ajax({
			type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
			url         : '/my_account/utils/account_update.php', // the url where we want to POST
			data        : formData, // our data object
			dataType    : 'json', // what type of data do we expect back from the server
			encode          : true
		})
			// using the done promise callback
			.done(function(data) {
				// Close please wait dialog
				$("#pets-wait").hide();

				if ( ! data.success) {
					// Error - show it to the user
					var error_message = '';
					$.each(data.errors, function (i,v) {
						error_message = error_message + "<br>" + v;
						$(i).addClass('missing-data');
					});
					$("#pets-err-msg").html(error_message);
					$("#pets-err").show();
				} else {
					// ALL GOOD! just show the success message!
					$("#fname_disp").html(data.fname);
					$("#lname_disp").html(data.lname);
					$("div#account_updated").show().effect("highlight", {color: '#A1FFAA', border: '1px solid #62c96c'}, 3000, function() { $(this).effect("blind", {}, 300); });
				}
			});
	});


	// Submission handler for edit password request
	$(document).on("click", "#edit_pwd_sub", function(e) {
		e.preventDefault();
		$("#pets-err").hide();
		$('#pets-wait-msg').html('<strong>Please Wait - saving changes</string> <i class="fa fa-spinner fa-pulse"></i>');
		$("#pets-wait").show();
		var formData = $('#password_form').serialize();
		// process the form
		$.ajax({
			type        : 'POST', // define the type of HTTP verb we want to use (POST for our form)
			url         : '/my_account/utils/password_update.php', // the url where we want to POST
			data        : formData, // our data object
			dataType    : 'json', // what type of data do we expect back from the server
			encode          : true
		})
			// using the done promise callback
			.done(function(data) {
				// Close please wait dialog
				$("#pets-wait").hide();

				if ( ! data.success) {
					// Error - show it to the user
					var error_message = '';
					$.each(data.errors, function (i,v) {
						error_message = error_message + "<br>" + v;
						$(i).addClass('missing-data');
					});
					$("#pets-err-msg").html(error_message);
					$("#pets-err").show();
				} else {
					// ALL GOOD! just show the success message!
					$("div#password_updated").show().effect("highlight", {color: '#A1FFAA', border: '1px solid #62c96c'}, 3000, function() { $(this).effect("blind", {}, 300); });
				}
			});
	});

	$(document).on('click', '.extend_pet', function(e){
		e.preventDefault();
		extendPet($(this).data('pet_id'));
	})


	// ---Password test functions---
	$(document).on('keyup', '#pwd_input', function (){
		var score = passwordStrength($(this).val());
		$("#passwordDescription").html(score.desc);
		$("#passwordStrength").attr('class',"strength" + score.val);
		$("#user_pass_strength").val(score.val);
	});

	$(document).on('keyup', '.pwd', function (){
		if ($("#pwd_conf").val()===$('#pwd_input').val()) {
			$('#pwd_matches').val('1');
			$('#pwd_blank').hide();
			$('#pwd_nomatch').hide();
			$('#pwd_match').show();
		}
		else {
			$('#pwd_matches').val('');
			$('#pwd_blank').hide();
			$('#pwd_nomatch').show();
			$('#pwd_match').hide();
		}
		if ($('#pwd_input').val()==='') {
			$('#pwd_blank').show();
			$('#pwd_nomatch').hide();
			$('#pwd_match').hide();
		}	else {
			$('#pwdstr').attr('required','required');
			$('#pwd_matches').attr('required','required');
		}

	});

});


function delPet(pet_id) {
	$('#pets-wait-msg').html('Deleting Pet');
	$('#pets-wait').show();
	$.ajax({
		type  : 'POST',
		url: '/utils/del_pet.php',
		dataType  : 'json',
		data : {
			'pet[pet_id]': pet_id,
			'del[reason]': $('#del_reason_input').val(),
			'del[descr]': $('#del_descr').val()
		},
		xhrFields: { withCredentials: true },
		crossDomain: true,
		encode  : true
	})
	.done(function(data) {
		$('#pets-wait').hide();
		if ( data.success == false ) {
			//console.log(data);
			$('#pets-err-msg').html('Unable to delete pet: ' + data.error_msg);
			$('#pets-err').show();
			$('#pets').hide();
		} else {
			$('#pet_' + pet_id).hide("slow",function(){
				$(this).remove();
			});
		}
	})
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.log(XMLHttpRequest);
		console.log(textStatus);
		console.log(errorThrown);
		$('#pets-wait').hide();
		$('#pets-err-msg').html('Unable to delete pet: ' + textStatus + ' ' + errorThrown);
		$('#pets-err').show();
	});
}

function extendPet(pet_id) {
	$('#pets-wait-msg').html('Deleting Pet');
	$('#pets-wait').show();
	$.ajax({
		type  : 'POST',
		url: '/utils/extend_pet.php',
		dataType  : 'json',
		data : {"pet_id": pet_id},
		xhrFields: { withCredentials: true },
		crossDomain: true,
		encode  : true
	})
	.done(function(data) {
		$('#pets-wait').hide();
		if ( data.success == false ) {
			//console.log(data);
			$('#pets-err-msg').html('Unable to extend pet: ' + data.error);
			$('#pets-err').show();
			$('#pets').hide();
		} else {
			$('#pet_' + data.pet_id).find('.extend_pet').remove();
			$('#pets-success-msg').text('Pet Listing Extended for 2 more weeks.');
			$('#pet_' + data.pet_id).find('.pet_exp_date').text(moment().add(2, 'w').format("MMM Do YYYY"));
			$('#pets-success').fadeIn();
			setTimeout(function(){
				$('#pets-success').fadeOut("slow");
			},5000)
		}
	})
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.log(XMLHttpRequest);
		console.log(textStatus);
		console.log(errorThrown);
		$('#pets-wait').hide();
		$('#pets-err-msg').html('Unable to extend pet: ' + textStatus + ' ' + errorThrown);
		$('#pets-err').show();
	});
}

